module.exports = __webpack_public_path__ + "static/media/sm-01.dec3582e.png";